import { toast } from "react-toastify";

export const notify = (message: string) => toast(message);

export const notifyError = (message: string) => toast.error(message);
